import { render, staticRenderFns } from "./PageLoadingProgress.vue?vue&type=template&id=2028ca3c&"
import script from "./PageLoadingProgress.vue?vue&type=script&lang=js&"
export * from "./PageLoadingProgress.vue?vue&type=script&lang=js&"
import style0 from "./PageLoadingProgress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VProgressCircular,VRow})
